export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'Free Consultation',
      description: 'We start with a complimentary consultation to understand your business needs, current bookkeeping challenges, and financial goals. This helps us create a customized plan for your El Paso business.',
      icon: 'ri-chat-3-line'
    },
    {
      number: '02',
      title: 'QuickBooks Setup & Integration',
      description: 'Our team sets up or optimizes your QuickBooks account, connects your bank accounts, and establishes a chart of accounts tailored to your industry and business structure.',
      icon: 'ri-settings-3-line'
    },
    {
      number: '03',
      title: 'Ongoing Bookkeeping',
      description: 'We handle your day-to-day bookkeeping tasks including transaction recording, invoice management, bank reconciliation, and financial reporting on a schedule that works for you.',
      icon: 'ri-refresh-line'
    },
    {
      number: '04',
      title: 'Regular Reports & Reviews',
      description: 'Receive monthly financial reports and quarterly reviews to keep you informed about your business performance. We are always available to answer questions and provide guidance.',
      icon: 'ri-file-text-line'
    }
  ];

  return (
    <section id="process" className="py-20 bg-gradient-to-b from-white to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            How Our <strong>Bookkeeping Process</strong> Works
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Getting started with professional <strong>bookkeeping services in El Paso</strong> is easy. Here is our simple four-step process to get your finances organized.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-xl p-8 shadow-lg h-full border-t-4 border-teal-500">
                <div className="text-6xl font-bold text-teal-100 mb-4">
                  {step.number}
                </div>
                <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mb-6">
                  <i className={`${step.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-teal-500 text-2xl"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
